import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@css/index.css'

import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)
import 'default-passive-events'

Vue.config.productionTip = false

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 引入指令
// import directive from '@/utils/directive';
// Vue.use(directive)


new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')
